import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Button, Container, Grid, Typography } from '@mui/material';
import { FileSelector } from '@jbrowse/core/ui';
import { load } from './util';
import ImportFormExamples from './ImportFormExamples';
export default observer(({ model }) => {
    const [msaFile, setMsaFile] = useState();
    const [treeFile, setTreeFile] = useState();
    const { error } = model;
    return (React.createElement(Container, null,
        React.createElement("div", { style: { width: '50%' } },
            error ? (React.createElement("div", { style: { padding: 20 } },
                React.createElement(Typography, { color: "error" },
                    "Error: ",
                    `${error}`))) : null,
            React.createElement(Typography, null, "Open an MSA file (stockholm or clustal format) and/or a tree file (newick format)."),
            React.createElement(Typography, { color: "error" }, "Note: you can open up just an MSA or just a tree, both are not required. Some MSA files e.g. stockholm format have an embedded tree also and this is fine, and opening a separate tree file is not required.")),
        React.createElement(Grid, { container: true, spacing: 10, justifyContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true },
                React.createElement(Typography, null, "MSA file or URL"),
                React.createElement(FileSelector, { location: msaFile, setLocation: setMsaFile }),
                React.createElement(Typography, null, "Tree file or URL"),
                React.createElement(FileSelector, { location: treeFile, setLocation: setTreeFile })),
            React.createElement(Grid, { item: true },
                React.createElement(Button, { onClick: () => load(model, msaFile, treeFile), variant: "contained", color: "primary", disabled: !msaFile && !treeFile }, "Open")),
            React.createElement(Grid, { item: true },
                React.createElement(Typography, null, "Examples"),
                React.createElement(ImportFormExamples, { model: model })))));
});
//# sourceMappingURL=index.js.map